module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0050.jpg?v=73ca5612";